import { useTranslation } from 'react-i18next';

interface AnalyticsModuleProps {
  agentId: string;
}

export const AnalyticsModule = ({ agentId }: AnalyticsModuleProps) => {
  const [t] = useTranslation('campaigns');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium text-gray-900">
          {t('analytics_dashboard')}
        </h2>
      </div>

      <div className="flex h-64 flex-col items-center justify-center text-center">
        <div className="mb-4 text-4xl">📊</div>
        <h3 className="text-lg font-medium text-gray-900">
          {t('analytics_coming_soon')}
        </h3>
        <p className="mt-2 text-sm text-gray-600">
          {t('analytics_coming_soon_description')}
        </p>
      </div>
    </div>
  );
};
